export default __webpack_public_path__ + "static/media/704.2f1d6086.gif";